<template>
    <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
        <a-card style="" :bordered="true" :title="$t('数据详情')">
          <!--
            <detail-list :col="2" v-if="!!model.idList">
                <a-textarea v-model="model.idList" placeholder="..." :rows="3" style="width:100%;" disabled />
            </detail-list>
            -->
            <detail-list :col="3">
                <template v-if="model.meterWarnType === 1">
                    <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                    <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
                    <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                    <detail-list-item :term="$t('信号rsrp值')">{{model.signalRsrp}}</detail-list-item>
                    <detail-list-item :term="$t('信号snr值')">{{model.signalSnr}}</detail-list-item>
                    <detail-list-item :term="$t('信号csq值')">{{model.signalCsq}}</detail-list-item>
                    <detail-list-item :term="$t('信号rsrq值')">{{model.signalRsrq}}</detail-list-item>
                    <detail-list-item :term="$t('信号覆盖等级')">{{model.signalClevel}}</detail-list-item>
                    <detail-list-item :term="$t('温度')">{{model.meterTemp}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('告警规则')">{{model.warnName}}</detail-list-item>
                    <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
                </template>
                <template v-else-if="model.meterWarnType === 3">
                    <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                    <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
                    <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('失联天数')">{{model.lostContactDay}}</detail-list-item>
                    <detail-list-item :term="$t('失联告警时间')">{{model.updateTime}}</detail-list-item>
                </template>
                <template v-else-if="model.meterWarnType === 4">
                    <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
                    <detail-list-item term="ST1/ST2">
                        <template v-if="model.meterType == '80'&&model.meterStatus3!=null">
                        0x{{model.meterStatus3.toString(16)}}
                        </template>
                        <template v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                        0x{{model.meterStatus2.toString(16)}}
                        </template>
                    </detail-list-item>
                    <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
                    <div v-if="model.meterType == '80'&&model.meterStatus3!=null">
                        <a-col :span="6" style="margin-bttom: 16px">
                        <span>bit7: {{(model.meterStatus3&128)!== 0?1:0}}(NRST:{{(model.meterStatus3&128)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit6: {{(model.meterStatus3&64)!== 0?1:0}}(css:{{(model.meterStatus3&64)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit5: {{(model.meterStatus3&32)!== 0?1:0}}(lockup:{{(model.meterStatus3&32)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit4: {{(model.meterStatus3&16)!== 0?1:0}}(PCA:{{(model.meterStatus3&16)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit3: {{(model.meterStatus3&8)!== 0?1:0}}(WDT:{{(model.meterStatus3&8)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span >bit2: {{(model.meterStatus3&4)!== 0?1:0}}(LVD:{{(model.meterStatus3&4)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit1: {{(model.meterStatus3&2)!== 0?1:0}}(bit1:{{(model.meterStatus3&2)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit0: {{(model.meterStatus3&1)!== 0?1:0}}(bit0:{{(model.meterStatus3&1)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                    </div>
                    <div v-else-if="model.meterType == '18'&&model.meterStatus2!=null">
                        <a-col :span="6" style="margin-bttom: 16px">
                        <span>bit7: {{(model.meterStatus2&128)!== 0?1:0}}(NRST:{{(model.meterStatus2&128)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit6: {{(model.meterStatus2&64)!== 0?1:0}}(css:{{(model.meterStatus2&64)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit5: {{(model.meterStatus2&32)!== 0?1:0}}(BORF:{{(model.meterStatus2&32)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit4: {{(model.meterStatus2&16)!== 0?1:0}}({{ $t('HSI标准') }}:{{(model.meterStatus2&16)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit3: {{(model.meterStatus2&8)!== 0?1:0}}(IWDGF:{{(model.meterStatus2&8)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span >bit2: {{(model.meterStatus2&4)!== 0?1:0}}(LLOPF:{{(model.meterStatus2&4)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit1: {{(model.meterStatus2&2)!== 0?1:0}}(SWIMF:{{(model.meterStatus2&2)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                        <a-col :span="6" style="margin-bottom: 16px">
                        <span>bit0: {{(model.meterStatus2&1)!== 0?1:0}}(PORF:{{(model.meterStatus2&1)!== 0?$t('有'):$t('无')}})</span>
                        </a-col>
                    </div>
                    
                </template>
                <template v-else-if="model.meterWarnType === 5">
                    <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                    <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
                    <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
                    <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
                    <detail-list-item :term="$t('信号rsrp值')">{{model.signalRsrp}}</detail-list-item>
                    <detail-list-item :term="$t('信号snr值')">{{model.signalSnr}}</detail-list-item>
                    <detail-list-item :term="$t('信号csq值')">{{model.signalCsq}}</detail-list-item>
                    <detail-list-item :term="$t('信号rsrq值')">{{model.signalRsrq}}</detail-list-item>
                    <detail-list-item :term="$t('信号覆盖等级')">{{model.signalClevel}}</detail-list-item>
                    <detail-list-item :term="$t('温度')">{{model.meterTemp}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('告警规则')">{{model.warnName}}</detail-list-item>
                    <detail-list-item :term="$t('告警时间')">{{model.updateTime}}</detail-list-item>
                </template>
                <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
                <detail-list-item :term="$t('处理时间')">{{model.meterWarnDealTime}}</detail-list-item>
                <detail-list-item :term="$t('处理描述')" :itemCol="1">{{model.meterDealStatus==2?model.meterWarnDealDescription2:model.meterDealStatus==1?model.meterWarnDealDescription1: model.meterWarnDealDescription0}}</detail-list-item>
            </detail-list>
        </a-card>
    </a-spin>
    </a-modal>
</template>

<script>

  import { postAction } from '@/api/manage'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  import {isUndefinedAndNull} from'@/utils/validate'
  const DetailListItem = DetailList.Item
  export default {
    name: 'meterWarnHistoryRecordDetailModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        model: {},
        netTypeObj,
        meterTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.disableSubmit = true;
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.model = this.$options.data.call(this).model;
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>